import 'github-markdown-css/github-markdown.css';

import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

const MarkdownRenderer = ({ markdown }: { markdown: string }) => {
  return (
    // `github-markdown-css` styles are all scoped under `.markdown-body` (see its own
    // stylesheet) — the class here must match that exactly, or every rule (headers, lists,
    // tables, code blocks, ...) silently fails to apply and everything renders as plain text.
    // Colors are re-themed onto this app's own tokens in shared/styles/tokens.css, since the
    // library's built-in dark mode only follows the OS's prefers-color-scheme / a literal
    // data-theme="dark", neither of which matches this app's own mflow-dark/mflow-light toggle.
    <div className="markdown-body">
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]} rehypePlugins={[rehypeHighlight]}>
        {markdown}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
